import { Injectable } from '@angular/core';
import { ApiEvsService } from 'app/common/services/ApiEvs.service';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { Headers, Http } from '@angular/http';

@Injectable()
export class LogsService {
  url = environment.qrcode_url;
  headers: Headers;
  constructor(
    private http: ApiEvsService,
    private http2: Http,
  ) {
    const token = localStorage.getItem('Access-Token');
    this.headers = new Headers({
      "Accept-Language": localStorage.getItem("lang") || "vi",
      'Content-Type': 'application/json',
      'Authorization': `${token}`
    });
  }

  public getLogsScan(data?: any) {
    return this.http.get('/logs/scan', data);
  }
  public getExcel(data?: any) {
    return this.http.getExcel('/logs/scan/excel', data);
  }
  public getLogsDetail(id?: any) {
    return this.http.get('/logs/scan/' + id);
  }
  public getLogsDetailLoyalty(id?: any, prefix?: any, number?: any): Observable<any> {
    return this.http2.get(`${this.url}/logs/scan/${id}/sale-out/loyalty?prefix=${prefix}&number=${number}`, { headers: this.headers }).map(res => {
      return res.json();
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/logs/logs.service.ts